import $ from "jquery";
import moment from "moment";
import app, { csl, u_, vuwer } from "@@assets/scripts/common";

const week = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

vuwer.appendKlass("VuwTopicList", {
	onReadyFirst($self) {
		!!$self && $self.addClass("vuw-topic-list");
	},
	
	/**
	 * データチェックとフォーマットを行う
	 * @param {Array} src: イベントデータ
	 * @param {Integer} [limit]: 表示件数の指定
	 * @return this
	 */
	setData(src, limit) {
		if( !Array.isArray(src) ) {
			throw new TypeError("arguments[0] must be array.");
		}
		
		const list = [];
		const byMonth = {};
		
		src.forEach(item => {
			if( !item.date || !u_.isString(item.date) ) {
				csl.warn("This topic item has no date.", { ...item });
				return true;
			}
			
			if( !item.title || !u_.isString(item.title) ) {
				csl.warn("This topic item has no title.", { ...item });
				return true;
			}
			
			item.date = moment(item.date);
			if( !item.date.isValid() ) {
				csl.warn("This topic item has no valid date.", { ...item });
				return true;
			}
			
			list.push(item);
		});
		
		// 日付昇順にソート
		list.sort((a, b) => {
			if( a.date.isBefore(b.date) ) {
				return -1;
			} else
			if( a.date.isAfter(b.date) ) {
				return 1;
			}
			
			return 0;
		});
		
		// limitが指定されている場合は、limit以降のデータを除外
		if( u_.isInteger(limit) ) {
			list.splice(0, list.length - limit);
		}
		
		// 年月ごとの配列を生成
		list.forEach(item => {
			const ym = item.date.format("YYYY-MM");
			Array.isArray(byMonth[ym]) || (byMonth[ym] = []);
			byMonth[ym].push(item);
			
			!!item.href && (item.href += u_.createQueryString({ ym }));
		});
		
		// 日付降順にソート
		list.sort((a, b) => {
			if( a.date.isAfter(b.date) ) {
				return -1;
			} else
			if( a.date.isBefore(b.date) ) {
				return 1;
			}
			
			return 0;
		});
		
		this.items = { list, byMonth };
		
		return this;
	},
	
	/**
	 * 一覧を描画
	 * @param {String} [ym]: 年月の指定（YYYY-MM）
	 * @return {Promise}
	 */
	async renderList(ym) {
		if(!this.$self) {
			csl.warn(`${this.getAddress()}: no DOM element.`);
		}
		
		const { items } = this;
		if( !u_.isObject(items) ) {
			csl.warn(`${this.getAddress()}: topic data is not set.`);
			return false;
		}
		
		u_.isString(ym) || (ym = false);
		
		this.$self.attr("data-is", "rendering");
		await new Promise(resolve => setTimeout(() => resolve(), 0));
		
		const list = !ym ? items.list : items.byMonth[ym];
		const records = !list ? [] : list.map(item => this._createRecord(item));
		
		await new Promise(resolve => setTimeout(() => resolve(), 400));
		this.$self.empty().append(...records).attr("data-is", "active");
		
		return records.length;
	},
	
	/**
	 * 一覧用レコードを生成
	 * @param {Object} item: setDataでフォーマットされたデータ
	 * @return {$Object}
	 */
	_createRecord(item) {
		const { date, title, href } = item;
		const { _relativePath } = app;
		
		const $elm = !href ? $("<div/>") : $("<a/>").attr({ href });
		if(href) {
			if( /^\//.test(href) ) {
				$elm.attr({ href: `${_relativePath}${href}` });
			}
			if( /^https?:/.test(href) || /\.pdf/.test(href) ) {
				$elm.attr({
					target: "_blank",
					rel: "noopener noreferrer"
				});
			}
		}
		$elm.addClass("topic-item");
		
		// [day]
		const dayOfWeek = week[date.days()];
		$("<div/>").addClass("day echoed-data").attr({
			"data-dow": dayOfWeek
		}).text(
			date.format("YYYY年MM月DD日（ddd）")
		).appendTo($elm);
		
		// [title]
		const $title = $("<div/>").addClass("title echoed-data").html(
			$.parseHTML(title)
		);
		
		$title.find("a").each((i, elm) => {
			const href = elm.getAttribute("href");
			if( /^\//.test(href) ) {
				elm.href = `${_relativePath}${href}`;
			}
			if( /^https?:/.test(href) || /\.pdf/.test(href) ) {
				elm.target = "_blank";
				elm.rel = "noopener noreferrer"
			}
		});
		
		$title.appendTo($elm);
		
		return $("<li/>").addClass("list-item").append($elm);
	}
});
